export default "__VITE_ASSET__1aJuAhYG__"